(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('[data-product-form]');

    forms.forEach(function (form) {
      form.addEventListener('submit', handleFormSubmit);
    });

    function handleFormSubmit(event) {
      event.preventDefault();

      var form = event.currentTarget;
      var submitButton = form.querySelector('[type="submit"]');
      var errorEl = form.querySelector('.product-form__error');
      var originalText = submitButton.textContent.trim();

      // Clear previous errors
      if (errorEl) {
        errorEl.style.display = 'none';
        errorEl.textContent = '';
      }

      // Set loading state
      setLoading(submitButton, true);

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart');
            });
          }
          return response.json();
        })
        .then(function (data) {
          // Success feedback
          setLoading(submitButton, false);
          submitButton.textContent = 'Added!';
          submitButton.style.backgroundColor = '#00B4D8';

          // Dispatch cart updated event
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { item: data }
            })
          );

          // Update cart count in header
          updateCartCount();

          // Reset button text after a short delay
          setTimeout(function () {
            submitButton.textContent = originalText;
            submitButton.style.backgroundColor = '';
          }, 2000);
        })
        .catch(function (error) {
          setLoading(submitButton, false);
          submitButton.textContent = originalText;

          if (errorEl) {
            errorEl.textContent = error.message || 'Could not add to cart';
            errorEl.style.display = 'block';
          }

          console.error('Add to cart error:', error);
        });
    }

    function setLoading(button, isLoading) {
      if (isLoading) {
        button.classList.add('product-form__submit--loading');
        button.disabled = true;
      } else {
        button.classList.remove('product-form__submit--loading');
        button.disabled = false;
      }
    }

    function updateCartCount() {
      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var countEls = document.querySelectorAll('[data-cart-count]');
          countEls.forEach(function (el) {
            el.textContent = cart.item_count;
          });

          // Also dispatch with full cart data
          document.dispatchEvent(
            new CustomEvent('cart:count-updated', {
              detail: { count: cart.item_count }
            })
          );
        })
        .catch(function (error) {
          console.error('Cart count update error:', error);
        });
    }
  });
})();
